import { Dispatch } from 'redux';
import backend from '../../../apis/backend';
import { ReduxState } from '../../state';
import { Transaction } from '../../page/types';
import { 
  getUserTransactionsSuccess,
  getUserTransactionsFailure
} from '../actions';

// Initiator for fetching user transactions
export const fetchUserTransactions = (userId: string, more: boolean = false) => {
  return async (dispatch: Dispatch, getState: () => ReduxState) => {
    try {
      // Get the loginToken from the Redux state
      const { auth } = getState();
      const loginToken = auth.loginToken;
      const { userTransactions, userTransactionsDetails } = getState().user;
      let fetchedUserTransactions: Transaction[] = [];
      // Construct the headers with X-Auth-Token
      const headers = {
        'X-Auth-Token': loginToken,
      };
      let url = `/commerce-service/api/v1/transactions?userId=${userId}&limit=10&sortBy=createdAt&sortDirection=desc&calculatePoints=1&type=payment`
      if (more && userTransactionsDetails.currentPage) {
        const nextPage = userTransactionsDetails.currentPage + 1
        url += `&page=${nextPage}`
      }
      const response = await backend.get(url,{ headers });

      if (response.status === 200) {
        const { totalItems, currentPage, totalPages, rewardPointsBalance } = response.data;
        const details = { totalItems, currentPage, totalPages, rewardPointsBalance };
        if (more) {
          fetchedUserTransactions = [...userTransactions].concat(response.data.transactions)
        } else {
          fetchedUserTransactions = response.data.transactions
        }      
        dispatch(getUserTransactionsSuccess({ transactions: fetchedUserTransactions, details }));
      } else {
        dispatch(getUserTransactionsFailure('Failed to fetch user transactions.'));
      }
    } catch (error) {
      console.error('Error fetching user transactions:', error);
      dispatch(
        getUserTransactionsFailure('An error occurred while fetching user transactions.')
      );
    }
  };
};